<template>
  <pu-popover>
    <template #content>
      <div class="privacy-popover-contents">
        <p>
          <translate tag="strong"> Private </translate><br /><translate>
            Only you can see this list.
          </translate>
        </p>
        <p>
          <translate tag="strong"> Public </translate><br /><translate>
            Anyone with the link can see this list. They can also add & remove
            favourites from it and add & edit the notes.
          </translate>
        </p>
      </div>
    </template>
  </pu-popover>
</template>

<script lang="ts" setup></script>

<style scoped>
.privacy-popover-contents {
  font-size: var(--body);
}
</style>
